/**
 * Documentation Controller
 */
function NapCtrl(
    WCConstants,
    categories,
    napService,
    authService,
    $window,
    $log
) {
    var vm = this;

    vm.version = WCConstants.version;
    vm.authInfos = authService.getAuthInfos();
    vm.categories = categories;
    vm.documentations = [];

    vm.handleCategoryClick = function (category) {
        // ensure only the appropriate category is selected (if we want to style it)
        angular.forEach(vm.categories, function unselect(c) {
            c.selected = false;
        });
        category.selected = true;

        napService.getDocumentations(category).then(function (documents) {

            vm.documentations = documents.filter(function (doc) {
                if(!doc.modules) {
                    return true;
                }
                // return vm.authInfos.data.data.modules.some(function(module) {
                //     return doc.modules.indexOf(module) >= 0;
                // });
                return true;
            });
        });
    };

    vm.handleDocumentationClick = function (documentation) {
        var url = documentation.url;
        if (url == null) {
            $log.info('URL inconnu pour la tuile sélectionnée', documentation); // TODO: open a pop-up for the end-user ?
            return;
        }
        $window.open(url, '_blank');
    };

    // if user is logged out in another tab, reload the portal
    $window.addEventListener('storage', function () {
        $window.location.reload();
    });

    vm.handleCategoryClick(vm.categories[0]);

    return vm;
}

angular.module('app.portail.nap').controller('NapCtrl', NapCtrl);
